/* eslint-disable @typescript-eslint/no-non-null-assertion */

import { IconName } from '@klp/design/Illustrations';
import { themeOptions } from '@klp/design/Theme/theme';
import { SidebarMenuItem } from '@klp/layout/Sidebar/classes/SidebarMenuItem';
import { generateRoute } from '@klp/routing';
import type { User } from '@klp/user';

import { getDefaultLanguage } from '../../layout/Sidebar/config';

export const AppModuleName = '/';

export const AppRoutes = {
    moduleRoute: () => generateRoute([AppModuleName]),
    mainPage: () => generateRoute([AppModuleName]),
};

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const AppFullAccess = (_user?: User): boolean => true;

export const AppMenuItems = [
    new SidebarMenuItem({
        route: AppRoutes.mainPage(),
        matchRoute: AppRoutes.moduleRoute(),
        icon: IconName.HOME,
        translation: 'frontPage.frontpage',
        access: AppFullAccess,
    }),
];

export const isMobileScreen = () =>
    window ? window.innerWidth < themeOptions.breakpoints!.values!.sm : false;
export const isSmallScreen = () =>
    window ? window.innerWidth < themeOptions.breakpoints!.values!.md : false;
export const isMediumScreen = () =>
    window ? window.innerWidth < themeOptions.breakpoints!.values!.lg : false;
export const isLargeScreen = () =>
    window ? window.innerWidth >= themeOptions.breakpoints!.values!.lg : false;

export const isDeploymentNo = () => getDefaultLanguage() === 'no';
export const isDeploymentSv = () => getDefaultLanguage() === 'sv';
export const isDeploymentDa = () => getDefaultLanguage() === 'da';
